import { useI18n } from 'vue-i18n'
import useBlProviders from '@/composables/providers/useBlProvider'
import WorksMaterialConsumptionRateNormsDt from '@/services/dataTransferModules/worksMaterialConsumptionRateNormsDt'

const worksMaterialConsumptionRateNormsDt = new WorksMaterialConsumptionRateNormsDt()

export default function useWorkMaterialConsumptionRateNorms() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: fullWorksMaterialConsumptionRateNorms,
		getEntities: getFulledWorksMaterialConsumptionRateNorm,

		basedEntities: baseWorksMaterialConsumptionRateNorms,
		getBasedEntities: getBasedWorksMaterialConsumptionRateNorm,

		extendedEntities: extendedWorksMaterialConsumptionRateNorms,
		getExtendedEntities: getExtendedWorksMaterialConsumptionRateNorm,

		entity: worksMaterialConsumptionRateNorm,
		getEntity: getWorksMaterialConsumptionRateNorm,

		createEntity: createWorksMaterialConsumptionRateNorm,

		patchEntity: updateWorksMaterialConsumptionRateNorm,

		updateEntity: fullUpdateWorksMaterialConsumptionRateNorm,

		deleteEntity: deleteWorksMaterialConsumptionRateNorm,
	} = useBlProviders(worksMaterialConsumptionRateNormsDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error while loading material consumption norms'),

		showErrorNotificationForLoadingBasedEntities: true,
		errorNotificationTextForLoadingBasedEntities: $t('Error while loading material consumption norms'),

		showErrorNotificationForLoadingExtendedEntities: true,
		errorNotificationTextForLoadingExtendedEntities: $t('Error while loading material consumption norms'),

		showErrorNotificationForLoadingOneEntity: true,
		showErrorNotificationForCreatingEntity: true,
		showErrorNotificationForUpdatingEntity: true,
		showErrorNotificationForDeletingEntity: true,
	})

	const defaults = {
		creatingWorksMaterialConsumptionRateNorm: {
			id: 0,
			name: '',
			metric: '',
			optimal_value: '',
			min_value: '',
			max_value: '',
			koef: '',
			work: null,
			material: null,
		},
		fieldsToPatch: [
			'name',
			'metric',
			'optimal_value',
			'min_value',
			'max_value',
			'koef',
			'work',
			'material',
		],
	}

	return {
		flags,
		fullWorksMaterialConsumptionRateNorms,
		baseWorksMaterialConsumptionRateNorms,
		extendedWorksMaterialConsumptionRateNorms,
		worksMaterialConsumptionRateNorm,
		defaults,
		getBasedWorksMaterialConsumptionRateNorm,
		getExtendedWorksMaterialConsumptionRateNorm,
		getFulledWorksMaterialConsumptionRateNorm,
		getWorksMaterialConsumptionRateNorm,
		createWorksMaterialConsumptionRateNorm,
		deleteWorksMaterialConsumptionRateNorm,
		updateWorksMaterialConsumptionRateNorm,
		fullUpdateWorksMaterialConsumptionRateNorm,
	}
}
